import './HubspotButton.scss';
import React, { useEffect, useState } from 'react';
import { Button, ButtonTone } from '@he-novation/design-system/components/buttons/Button/Button';
import { Loader, LoaderSize } from '@he-novation/design-system/components/widgets/Loader/Loader';
import { asyncFetchHubspotIdentificationParams } from '@he-novation/front-shared/async/hubspot.async';

const HUBSPOT_IDENTIFICATION_TOKEN_LIFETIME = 12 * 3_600_000; // 12 hours in milliseconds

export function HubspotButton() {
    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const toggleChatWindow = () => {
            const el = document.getElementById('hubspot-messages-iframe-container');
            if (el && window.HubSpotConversations) {
                if (isOpen) window.HubSpotConversations.widget.open();
                else window.HubSpotConversations.widget.close();

                el.classList.toggle('is-open', isOpen);
            }
        };

        if (!isOpen) {
            toggleChatWindow();
            return;
        }

        const hubspotConfigCheck = new Promise((resolve, reject) => {
            setIsLoading(true);

            if (
                window.hsConversationsSettings?.identificationTimestamp &&
                window.hsConversationsSettings?.identificationTimestamp +
                    HUBSPOT_IDENTIFICATION_TOKEN_LIFETIME >
                    new Date().getTime()
            ) {
                resolve(null);
            } else {
                asyncFetchHubspotIdentificationParams()
                    .then((identification) => {
                        window.hsConversationsSettings = {
                            ...window.hsConversationsSettings,
                            ...identification,
                            identificationTimestamp: new Date().getTime()
                        };
                    })
                    .catch((e) => console.error('Identification failed:', e))
                    .then(() => {
                        const onConversationsAPIReady = () => {
                            window.HubSpotConversations.on('widgetLoaded', () => resolve(null));
                            window.HubSpotConversations.widget.load();
                        };

                        if (window.HubSpotConversations) {
                            onConversationsAPIReady();
                        } else {
                            window.hsConversationsOnReady = [onConversationsAPIReady];
                        }
                    })
                    .catch(reject);
            }
        });

        hubspotConfigCheck.finally(() => {
            setIsLoading(false);
            toggleChatWindow();
        });
    }, [isOpen]);

    return (
        <Button id="c-hubspot-button" tone={ButtonTone.Dark} onClick={() => setIsOpen(!isOpen)}>
            {isLoading ? <Loader size={LoaderSize.Small} /> : '?'}
        </Button>
    );
}
